<app-plans-chooser
  (select)="handlePlanSelect($event)"
  [pending]="pending"
  [defaultPlanCode]="defaultPlanCode"
></app-plans-chooser>
